module.exports = __webpack_public_path__ + "static/img/stay.230c036c.svg";